import { isFinanceProject, isGlobalProject } from 'config';

export const getLegalClientFinancialMonitoringFormSectionKeys = (): string[] => {
  if (isFinanceProject()) {
    return ['financeFinancialMonitoring'];
  }

  if (isGlobalProject()) {
    return ['globalFinancialMonitoring'];
  }

  return [];
};
